import React from 'react';
import AdminLayout from '../components/AdminLayout';
import { AdminAILibraryCard } from '../components/AdminAILibraryCard';

/**
 * Dedicated Admin page for the AI music library. Renders the same card
 * we already surface in Settings so the code stays DRY, but promotes it
 * to a first-class navigation item alongside Venues / Playlists /
 * Forensics.
 */
export default function AdminAILibraryPage() {
  return (
    <AdminLayout>
      <div className="p-4 sm:p-6 lg:p-8 max-w-6xl mx-auto space-y-6">
        <header>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#39FF14] font-bold">Super Admin</p>
          <h1 className="text-3xl font-extrabold tracking-tight mt-1">AI Music Library</h1>
          <p className="text-sm text-gray-400 mt-1">
            Every track producers have uploaded. Search, retag, or remove.
            Uploads happen from the <span className="text-white font-semibold">/producer</span> dashboard.
          </p>
        </header>
        <AdminAILibraryCard />
      </div>
    </AdminLayout>
  );
}
